import { render, staticRenderFns } from "./UpNext.vue?vue&type=template&id=6826cf21&"
import script from "./UpNext.vue?vue&type=script&lang=js&"
export * from "./UpNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports